import {
  FilterOperator,
  OrderType,
  QConfigStatus,
  useSearchQConfigsQuery,
} from '@exam-management/graphql';
import { useParams } from '@exam-management/router';
import { FormSearchSelection, type FormSearchSelectionProps } from '@shared/components';
import { useMemo } from 'react';
import { type FieldValues } from 'react-hook-form';

type FormSearchQConfigSelectionProps<TFieldValues extends FieldValues> = Omit<
  FormSearchSelectionProps<TFieldValues>,
  'options'
>;

export default function QConfigSearchSelection<TFieldValues extends FieldValues>(
  props: Readonly<FormSearchQConfigSelectionProps<TFieldValues>>,
) {
  const { courseId } = useParams('/exam-courses/:courseId/qsets');
  const { data: qConfigData, loading: isSearchingQConfigs } = useSearchQConfigsQuery({
    variables: {
      searchQConfigsInput: {
        filter: {
          conditions: [
            {
              field: 'examCourseId',
              operator: FilterOperator.Equal,
              value: courseId,
            },
            {
              field: 'status',
              operator: FilterOperator.Equal,
              value: QConfigStatus.Published,
            },
          ],
        },
        order: {
          field: 'updatedAt',
          type: OrderType.Desc,
        },
        paging: {
          currentPage: 0,
          pageSize: 200,
        },
      },
    },
  });

  const qConfigOptions = useMemo(() => {
    return (qConfigData?.excSearchQConfigs.qConfigs ?? []).map((qConfig) => ({
      label: qConfig.name,
      value: qConfig.id,
    }));
  }, [qConfigData]);

  return (
    <FormSearchSelection
      {...props}
      noOptionsText='ไม่มี QConfig'
      label='เลือก QConfig'
      placeholder='เลือก QConfig'
      options={qConfigOptions}
      loading={isSearchingQConfigs}
    />
  );
}
